import React from 'react';
import { List, Collapse } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import SideNavBarTile from '../SideNavBarTile';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import type { CSSObject } from 'tss-react';

export interface CollapsableListProps {
  icon: React.ReactNode;
  mainTileLabel: string;
  subTiles: React.ReactNode[];
  initialState?: boolean;
  isOpen?: boolean;
  handleDropDownClick: any;
  currentState?: boolean;
  tabIndex?: number;
  handleActiveDropdownTab?: any;
  sideNavBarTileRootStyles?: CSSObject;
  sideNavBarLabelTextStyles?: string;
  width?: string;
}

const useStyles = makeStyles()({
  label: {
    fontWeight: 600,
    fontSize: '14px',
    color: patientAccessTheme.palette.navigationBar?.navTitle,
    lineHeight: '24px',
  },
});

const CollapsableList: React.FC<CollapsableListProps> = ({
  icon,
  mainTileLabel,
  subTiles,
  initialState,
  isOpen,
  handleDropDownClick,
  tabIndex,
  currentState,
  handleActiveDropdownTab,
  sideNavBarTileRootStyles,
  sideNavBarLabelTextStyles,
  width,
}) => {
  const { classes } = useStyles();

  return (
    <List
      component="nav"
      style={{
        padding: '0px',
        maxWidth: width ?? '250px',
      }}
    >
      <SideNavBarTile
        label={mainTileLabel}
        onClick={handleDropDownClick}
        startIcon={icon}
        showDropDownIcon={true}
        labelTextStyles={sideNavBarLabelTextStyles ?? classes.label}
        isOpen={isOpen}
        isActive={initialState}
        borderLeftString={
          initialState
            ? '4px solid ' + patientAccessTheme.palette.navigationBar?.navTitle
            : 'none'
        }
        bgColorString={
          initialState
            ? patientAccessTheme.palette.navigationBar?.titleBg
            : 'inherit'
        }
        currentState={currentState}
        tabIndex={tabIndex}
        handleActiveDropdownTab={handleActiveDropdownTab}
        rootStyles={sideNavBarTileRootStyles}
      />
      <Collapse in={currentState && isOpen} timeout="auto" unmountOnExit>
        <List component="div" style={{ padding: '12px 0px 0px 0px' }}>
          {subTiles}
        </List>
      </Collapse>
    </List>
  );
};

export default CollapsableList;
